export default __webpack_public_path__ + "static/media/Marvin 400.508bb2de.otf";